import { render, staticRenderFns } from "./item-noti.vue?vue&type=template&id=70f18bb1"
import script from "./item-noti.vue?vue&type=script&lang=js"
export * from "./item-noti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports